const SEMANTIC = {
  success: "#107e3e", warning: "#e9730c", error: "#bb0000", info: "#0a6ed1", neutral: "#6a6d70",
};

const STATUS_SEMANTIC = {
  OK: "success", CONFIRMED: "success", INVOICED: "success", GR_COMPLETE: "success",
  PASS: "success", PROCESSED: "success", RUNNING: "success", DELIVERED: "success",
  GOODS_ISSUED: "success", COMPLETED: "success",
  IN_PROGRESS: "warning", IN_DELIVERY: "warning", PARTIAL_GR: "warning", PENDING: "warning",
  STORING: "warning", OCCUPIED: "warning", PICKED: "warning",
  LOW: "error", FAIL: "error", ERROR: "error", OUT: "error",
  RELEASED: "info", ORDERED: "info", MOVING: "info", RETRIEVING: "info", IN_TRANSIT: "info",
  CREATED: "neutral", TECO: "neutral", OPEN: "neutral", IDLE: "neutral", EMPTY: "neutral", DRAFT: "neutral",
};

export default function StatusBadge({ status }) {
  const color = SEMANTIC[STATUS_SEMANTIC[status]] || SEMANTIC.neutral;
  return (
    <span
      data-testid={`status-${status}`}
      className="inline-flex items-center gap-1.5 text-xs font-medium"
      style={{ color }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      {(status || "—").replace(/_/g, " ")}
    </span>
  );
}
